import type { LucideIcon } from "lucide-react";
import { Building2, MapPin } from "lucide-react";

import { cn } from "@/lib/utils";

export type GrantCatalogScope = "federal" | "regional";

export type DiscoverGrant = {
  id: number;
  program_number: string | null;
  name: string;
  description: string | null;
  eligibility?: string | null;
  url?: string | null;
  scope?: GrantCatalogScope;
  state?: string | null;
  fit_tier?: GrantFitTier;
};

export function grantScopeMeta(grant: Pick<DiscoverGrant, "scope" | "state" | "program_number">): {
  label: string;
  icon: LucideIcon;
  badgeClass: string;
} {
  if (grant.scope === "regional") {
    return {
      label: grant.state ? `Regional · ${grant.state}` : "Regional program",
      icon: MapPin,
      badgeClass: "bg-violet-100 text-violet-800 dark:bg-violet-950/50 dark:text-violet-200",
    };
  }
  return {
    label: grant.program_number ? `Federal · ${grant.program_number}` : "Federal program",
    icon: Building2,
    badgeClass: "bg-sky-100 text-sky-800 dark:bg-sky-950/50 dark:text-sky-200",
  };
}

export function grantCardSurfaceClass(): string {
  return cn(
    "group relative flex flex-col overflow-hidden transition-shadow duration-200",
    "hover:shadow-md",
  );
}

export const DISCOVER_QUICK_TOPICS = [
  "Affordable housing and community development",
  "Water and stormwater infrastructure",
  "Public safety equipment and training",
  "Downtown revitalization and economic development",
  "Broadband and digital equity",
] as const;

export const discoverHeroClass =
  "relative overflow-hidden rounded-xl border bg-gradient-to-br from-emerald-50/90 via-background to-sky-50/80 p-4 sm:p-5 dark:from-emerald-950/30 dark:via-background dark:to-sky-950/20";

export const discoverSectionHeaderClass =
  "flex flex-wrap items-end justify-between gap-3 border-b border-border/60 pb-3";
